import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert, FormGroup, Label, Input } from 'reactstrap';
import RhPracticantesService from '../../axios_services/rh_practicantes.service';
import { AppContext } from '../../application/provider';

const ModalValidacionPracticantes = ({ isOpen, onClose, onRefresh, periodo, areaId, data }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);

    // Filtrar solo los registrados
    const registros = data || [];
    
    // Obtener el estado de validación actual
    const currentValId = registros.length > 0 ? Number(registros[0].validacion_id) : null;
    const currentAreaId = Number(areaId);

    const areaNames = {
        '1': 'ADMINISTRACIÓN',
        '2': 'NEGOCIOS',
        '4': 'GERENCIA',
    };

    const getEstadoNombre = (valId) => {
        if (valId === 0) return 'PENDIENTE';
        if (valId === 2) return 'VALIDADO POR TALENTO HUMANO';
        if (valId === 3) return 'VALIDADO POR GERENCIA DE NEGOCIOS';
        if (valId === 4) return 'VALIDADO POR SUBGERENCIA ADMINISTRATIVA';
        if (valId === 5) return 'VALIDADO POR GERENCIA GENERAL';
        if (valId === 6) return 'OBSERVADO / RECHAZADO';
        return 'DESCONOCIDO';
    };

    const handleAction = async (accion) => {
        setIsLoading(true);
        try {
            const response = await RhPracticantesService.validarPlanilla(
                periodo,
                parseInt(areaId),
                accion,
                state.user?.usuario_id
            );
            
            alert(response.message || 'Operación realizada con éxito');
            if (onRefresh) onRefresh();
            onClose();
        } catch (error) {
            console.error('Error al validar planilla practicantes:', error);
            const msg = error.response?.data?.error || error.message || 'Error de conexión';
            alert('Ocurrió un error: ' + msg);
        } finally {
            setIsLoading(false);
        }
    };

    // Botones de acción
    let canApprove = false;
    let approveMessage = '';
    const userProfile = state.user?.perfil_id ? parseInt(state.user.perfil_id) : 0;
    
    if (userProfile === 8) {
        canApprove = true;
    } else if (userProfile === 5 && (currentValId === 0 || currentValId === 6)) {
        canApprove = true;
    } else if (userProfile === 1 && currentAreaId === 2 && currentValId === 2) {
        canApprove = true;
    } else if (userProfile === 26 && [1, 4].includes(currentAreaId) && currentValId === 2) {
        canApprove = true;
    } else if (userProfile === 9 && (currentValId === 3 || currentValId === 4)) {
        canApprove = true;
    } else {
        if (currentValId >= 2 && userProfile === 5) approveMessage = 'Ya fue validado por Talento Humano.';
        else if (currentValId >= 3 && userProfile === 1) approveMessage = 'Ya fue validado por Gerencia de Negocios.';
        else if (currentValId >= 4 && userProfile === 26) approveMessage = 'Ya fue validado por Subgerencia.';
        else if (currentValId === 5 && userProfile === 9) approveMessage = 'Ya fue validado por Gerencia General (Finalizado).';
        else approveMessage = 'No es su turno para validar o ya fue validado.';
    }

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="md" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>VALIDACIÓN PLANILLA PRACTICANTES</h1>
                    <button className="close-btn" onClick={onClose} disabled={isLoading}>X</button>
                </div>
            </ModalHeader>
            
            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    {registros.length === 0 ? (
                        <Alert color="warning" className="m-0">
                            No hay registros en esta área para el periodo seleccionado.
                        </Alert>
                    ) : (
                        <div className="px-4">
                            <p className="text-muted mb-4" style={{ fontSize: '12px', lineHeight: '1.2' }}>
                                Resumen de validación masiva para el periodo seleccionado.
                            </p>

                            <FormGroup className="mb-3">
                                <Label className="fw-bold">Periodo:</Label>
                                <Input 
                                    type="text"
                                    className="form-control"
                                    value={periodo}
                                    readOnly
                                    style={{ backgroundColor: '#f8f9fa' }}
                                />
                            </FormGroup>
                            
                            <FormGroup className="mb-3">
                                <Label className="fw-bold">Área:</Label>
                                <Input 
                                    type="text"
                                    className="form-control"
                                    value={areaNames[areaId] || `Área ${areaId}`}
                                    readOnly
                                    style={{ backgroundColor: '#f8f9fa' }}
                                />
                            </FormGroup>

                            <FormGroup className="mb-3">
                                <Label className="fw-bold">Estado actual:</Label>
                                <Input 
                                    type="text"
                                    className="form-control"
                                    value={getEstadoNombre(currentValId)}
                                    readOnly
                                    style={{ backgroundColor: '#f8f9fa' }}
                                />
                            </FormGroup>

                            <FormGroup className="mb-4">
                                <Label className="fw-bold">Total registros:</Label>
                                <Input 
                                    type="text"
                                    className="form-control"
                                    value={registros.length}
                                    readOnly
                                    style={{ backgroundColor: '#f8f9fa' }}
                                />
                            </FormGroup>

                            {!canApprove && approveMessage && (
                                <Alert color="secondary" className="text-center font-bold m-0 p-2 text-sm">
                                    {approveMessage}
                                </Alert>
                            )}
                        </div>
                    )}
                </ModalBody>
                
                <ModalFooter className="flex justify-end p-4 border-t border-gray-200" style={{ padding: '15px' }}>
                    {registros.length > 0 && (
                        <div className="flex gap-4">
                            <Button 
                                color="danger" 
                                onClick={() => handleAction('rechazar')} 
                                disabled={isLoading}
                                style={{ width: '130px', borderRadius: '8px' }}
                            >
                                Rechazar
                            </Button>
                            {canApprove && (
                                <Button 
                                    color="success" 
                                    onClick={() => handleAction('validar')} 
                                    disabled={isLoading}
                                    style={{ width: '130px', borderRadius: '8px' }}
                                >
                                    Aprobar
                                </Button>
                            )}
                        </div>
                    )}
                </ModalFooter>
            </div>
        </Modal>
    );
};

export default ModalValidacionPracticantes;
